// src/telemetry/postCapsOnce.ts
import LoggingService from "services/logging";
import { getCachedReport } from "./capabilitiesReporter.ts"; //this does exist its just the linter failing

const SENT_COOKIE_PREFIX = "gc_caps_sent_";

function hasSentCookie(uniqueId: string): boolean {
    try {
        const name = `${SENT_COOKIE_PREFIX}${uniqueId}=`;
        return document.cookie.split("; ").some((c) => c.startsWith(name));
    } catch {
        return false;
    }
}

function setSentCookie(uniqueId: string): void {
    try {
        document.cookie = `${SENT_COOKIE_PREFIX}${uniqueId}=1; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/; SameSite=Lax`;
    } catch { }
}

/** Call this when a room is created. */
export async function postCapabilitiesOncePerDevice(): Promise<void> {
    const report = getCachedReport();
    const uniqueId = localStorage.getItem("uniqueId");

    if (!report || !uniqueId) return;

    if (hasSentCookie(uniqueId)) return; // only skip if this ID has already logged

    var result = await LoggingService.logDeviceCapabilities({
        UniqueId: uniqueId,
        Data: report,
    });

    if (result?.logged === true) setSentCookie(uniqueId);
}
